var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScjail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE1\x84\x80\xE1\x85\xB3\xE1\x86\xB7\xE1\x84\x8B\xE1\x85\xB2\xE1\x86\xBC\xE1\x84\x8B\xE1\x85\xA1\xE1\x84\x8B\xE1\x85\xB5\xE1\x84\x8F\xE1\x85\xA9\xE1\x86\xAB_SVG_SC\xE1\x84\x8C\xE1\x85\xA6\xE1\x84\x8B\xE1\x85\xB5\xE1\x86\xAF 1",
    clipPath: "url(#clip0_1736_9951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9562 0.012652C5.33599 0.311096 0.211098 5.91999 0.512654 12.5415C0.81421 19.1631 6.42177 24.2853 13.0429 23.9875C19.664 23.6898 24.788 18.0764 24.4873 11.4567C24.1867 4.83687 18.5787 -0.288904 11.9562 0.012652Z",
    fill: "#0F7AED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.3622 7.77539C14.8391 7.77539 13.0938 9.05806 13.0938 9.05806C13.0938 9.05806 14.8391 10.3412 15.3622 10.3412C16.0913 10.3412 16.6991 9.84806 16.6991 9.05806C16.6991 8.26806 16.0913 7.77539 15.3622 7.77539Z",
    fill: "#38D200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.42798 19.2005C9.95109 19.2005 11.6964 17.9179 11.6964 17.9179C11.6964 17.9179 9.95264 16.6348 9.42798 16.6348C8.69886 16.6348 8.09131 17.1279 8.09131 17.9179C8.09131 18.7079 8.69998 19.2005 9.42798 19.2005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.8178 12.0889L11.3 9.08556L13.9107 7.25734C14.5136 6.83512 14.7009 6.00156 14.2885 5.39067C14.0909 5.09631 13.7845 4.89247 13.4367 4.824C13.0888 4.75553 12.728 4.82803 12.4336 5.02556L12.4127 5.03978L9.2936 7.24445C8.99919 7.45244 8.7599 7.72907 8.59648 8.05037C8.43305 8.37167 8.35041 8.72797 8.35571 9.0884C8.361 9.44884 8.45408 9.80256 8.62688 10.1189C8.79967 10.4353 9.04698 10.7048 9.34738 10.904L16.4083 15.5838C17.2112 14.3473 17.0556 12.892 15.8178 12.0889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.59948 11.6836L16.3859 16.6896C16.6834 16.8812 16.8927 17.1832 16.9677 17.529C17.0427 17.8749 16.9773 18.2364 16.7859 18.534C16.5943 18.8315 16.2923 19.0408 15.9465 19.1158C15.6006 19.1908 15.2392 19.1254 14.9415 18.934L9.40148 15.3732C8.80608 14.9902 8.38713 14.3865 8.23674 13.6947C8.08635 13.003 8.21682 12.2798 8.59948 11.6843V11.6836Z",
    fill: "#38D200"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1736_9951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScjail);
export default __webpack_public_path__ + "static/media/scjail.0168aa0c1312d9cdedb63fa9b758f77e.svg";
export { ForwardRef as ReactComponent };